import { render, staticRenderFns } from "./absence.vue?vue&type=template&id=2418c4ad&scoped=true&"
import script from "./absence.vue?vue&type=script&lang=js&"
export * from "./absence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418c4ad",
  null
  
)

export default component.exports